var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindTurbine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.33 11.67L16.21 14.58C17.62 13.16 16.21 11.75 16.21 11.75L14.72 10.24C14.9 9.86001 15 9.44001 15 9.00001C15 7.95001 14.46 7.03001 13.64 6.50001L15 2.11001C13.09 1.53001 12.5 3.44001 12.5 3.44001L11.69 6.03001C10.46 6.16001 9.45998 7.00001 9.12998 8.18001L4.66998 9.63001C5.30998 11.53 7.19998 10.9 7.19998 10.9L9.26998 10.23C9.60998 10.97 10.23 11.54 11 11.82V19C11 19 8.99998 19 8.99998 21C8.99998 21.5 8.99998 21.81 8.99998 22H15V21C15 21 15 19 13 19V11.82C13.12 11.78 13.23 11.72 13.33 11.67ZM10.5 9.00001C10.5 8.60218 10.658 8.22065 10.9393 7.93935C11.2206 7.65804 11.6022 7.50001 12 7.50001C12.3978 7.50001 12.7793 7.65804 13.0606 7.93935C13.3419 8.22065 13.5 8.60218 13.5 9.00001C13.5 9.39783 13.3419 9.77937 13.0606 10.0607C12.7793 10.342 12.3978 10.5 12 10.5C11.6022 10.5 11.2206 10.342 10.9393 10.0607C10.658 9.77937 10.5 9.39783 10.5 9.00001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindTurbine);
export default __webpack_public_path__ + "static/media/wind-turbine.0345e558cfe2e8d622d9964a26e27df5.svg";
export { ForwardRef as ReactComponent };